import { render } from "./GroupSetting.vue?vue&type=template&id=667ace8c&scoped=true"
import script from "./GroupSetting.vue?vue&type=script&lang=js"
export * from "./GroupSetting.vue?vue&type=script&lang=js"

import "./GroupSetting.vue?vue&type=style&index=0&id=667ace8c&scoped=scoped&lang=css"
import "./GroupSetting.vue?vue&type=style&index=1&id=667ace8c&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667ace8c"]])

export default __exports__